import { lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import { usePageTracking } from './hooks/usePageTracking'
import Layout from './components/Layout'
import Home from './pages/Home'
import CategoryHub from './pages/CategoryHub'
import NotFound from './pages/NotFound'
import { CATEGORIES, TOOLS } from './data/tools'
import { TOOL_COMPONENTS } from './routes/toolComponents'

/**
 * Eager: Layout, Home (the LCP route), CategoryHub (tiny, shares the registry) and
 * NotFound. Everything else is code-split — see src/routes/toolComponents.js for tools.
 * blogPosts.js alone is ~8.6k lines, so the blog routes are the biggest win after pdf-lib.
 */
const BlogIndex = lazy(() => import('./pages/BlogIndex'))
const BlogPost = lazy(() => import('./pages/BlogPost'))
const About = lazy(() => import('./pages/About'))
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'))
const TermsOfService = lazy(() => import('./pages/TermsOfService'))
const Contact = lazy(() => import('./pages/Contact'))

function App() {
  usePageTracking()

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="blog" element={<BlogIndex />} />
        <Route path="blog/:slug" element={<BlogPost />} />
        <Route path="about" element={<About />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
        <Route path="contact" element={<Contact />} />

        {/* Category hubs */}
        {CATEGORIES.map((c) => (
          <Route key={c.id} path={c.route} element={<CategoryHub hubId={c.id} />} />
        ))}

        {/* One route per tool, generated from the registry */}
        {TOOLS.map((tool) => {
          const Component = TOOL_COMPONENTS[tool.slug]
          return <Route key={tool.slug} path={tool.slug} element={<Component />} />
        })}

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

export default App
